module.exports = __webpack_public_path__ + "static/img/institution07.069c053.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution07.png
// module id = KzEo
// module chunks = 1